import { ActionButtonTheme, NavHeaderTheme } from "@repo/ui/v2";

export const owletTheme: NavHeaderTheme = {
  container:
    "fixed top-0 left-0 right-0 z-10 bg-[rgba(6,7,39,0.75)] backdrop-blur-[7.5px] px-4",
  text: "text-[rgb(var(--black-200))] text-base font-normal text-center",
  button: "",
  spacer: "w-10",
  subtitleContainer: "w-full text-center bg-purple-secondary pb-2",
  subtitleText: "text-purple-accent text-sm",
};

// Base button theme with common properties
const baseButtonTheme: ActionButtonTheme = {
  base: "flex items-center justify-center w-full px-6 py-3 rounded-lg font-source-sans text-[16px] font-semibold leading-6 transition-opacity duration-200 cursor-pointer border-0",
  hover: "hover:opacity-90",
  active: "active:opacity-80",
  disabled: "disabled:cursor-not-allowed",
  focus: "",
  loading: "",
  pill: "",
};

// Action Button Theme configurations for different button variants
export const primaryButtonTheme: ActionButtonTheme = {
  ...baseButtonTheme,
  base: `${baseButtonTheme.base} bg-on-action-primary text-background`,
  disabled: `${baseButtonTheme.disabled} opacity-40`,
};

export const secondaryButtonTheme: ActionButtonTheme = {
  ...baseButtonTheme,
  base: `${baseButtonTheme.base} bg-transparent text-on-action-primary`,
};

export const ghostButtonTheme: ActionButtonTheme = {
  ...baseButtonTheme,
  base: `${baseButtonTheme.base} bg-transparent text-on-surface`,
};
